import React from 'react';
import {Modal} from '../../../components';
import {getStatusTextAndStyles} from 'helpers/getStatusTextAndStyles';
import {X} from 'lucide-react';
import * as Actions from '../../../store/actions';
import {connect} from 'react-redux';
import {getLighterShade} from 'routes/EasyOnboard/colorUtils';
import {qrSample} from 'assets/images/images';
import moment from 'moment';

function InvoiceDetailsModal({show, onClose, auth: {userDetails}, invoice}) {
  const baseColor = userDetails?.company?.color_code || '#3f7cdb';
  const lighterShadeDeep = getLighterShade(baseColor, 90);

  if (!invoice) return null;

  const invoiceDetails = [
    {
      label: 'Business Name',
      value: invoice.business_name || 'Test Business',
    },
    {
      label: 'Business ID',
      value: invoice.id,
    },
    {
      label: 'IRN',
      value: invoice.irn,
    },
    {
      label: 'Issue Date',
      value: moment(invoice.issue_date).format('Do MMM, YYYY'),
    },
    {
      label: 'Due Date',
      value: moment(invoice.due_date).format('Do MMM, YYYY'),
    },
    {
      label: 'Amount',
      value: `₦${Number(invoice.amount).toLocaleString()}`,
    },
  ];

  return (
    <Modal
      show={show}
      onClose={onClose}
      extraModalClasses="max-w-[528px] rounded-none absolute bottom-0 sm:relative h-fit max-h-full overflow-y-auto lookup-modal"
      modalPosition="items-start justify-end !p-0"
      fullScreenModal
    >
      <div className="">
        <header className="mt-6 sm:mt-0 px-6 py-3 border-transparent border-[0.5px] border-b-[#E4E4E6] flex items-center justify-between flex-wrap sm:flex-nowrap print:hidden">
          <div className="flex items-center gap-2 flex-col sm:flex-row">
            <h3 className="text-deepBlue text-base font-semibold">
              Invoice Details
            </h3>
            <span
              className={`uppercase py-1 px-2 text-[10px] rounded-full ${
                getStatusTextAndStyles(invoice.invoice_status?.toLowerCase())
                  .styles
              }`}
            >
              {getStatusTextAndStyles(invoice.invoice_status?.toLowerCase())
                .text || '-'}
            </span>
          </div>
          <button
            onClick={() => {
              onClose(false);
            }}
            className="bg-[#EDEDED] hidden sm:block rounded-md p-1.5"
          >
            <X size={16} color="#242424" />
          </button>
        </header>
        <div className="mt-8 px-6 flex items-center gap-4">
          <div
            style={{
              backgroundColor: lighterShadeDeep,
              borderColor: 'rgba(230, 240, 255, 0.5)',
            }}
            className="rounded-lg flex flex-col gap-2 items-center justify-center p-2 w-full h-[200px]"
          >
            <img className="w-40 h-40" src={qrSample} alt="qr image" />
            <p className="text-sm text-grey-500">
              You can scan it using your{' '}
              <a
                href="https://einvoice.firs.gov.ng/tools/mbs360"
                target="_blank"
                rel="noopener noreferrer"
                className="text-brandBlue hover:underline"
              >
                MBS360
              </a>{' '}
              mobile app
            </p>
          </div>
        </div>

        <div className="border border-t-[#EFEFEF] mt-7 border-transparent px-6 py-3 -mx-4 sm:mx-0 rounded">
          {invoiceDetails.map(({label, value}) => (
            <div
              key={label}
              className="py-3.5 flex items-center justify-between"
            >
              <p className="text-small text-deepBlue font-medium capitalize text-left">
                {label}
              </p>

              <p className="text-sm text-[#5C688E] font-normal w-100 text-right">
                {value || '-'}
              </p>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
}

export default connect(state => state, Actions)(InvoiceDetailsModal);
